<template>
  <div>
    <disqualifier-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :owners="owners" @add="add" @edit="edit"/>
    <disqualifier-detail v-show="activeKey===2" ref="detail" :order-type="orderType" :orderStatus="orderStatus" :owners="owners" @back="back"/>
  </div>
</template>

<script>
import DisqualifierList from '@/views/quality/disqualification/DisqualifierList.vue'
import DisqualifierDetail from '@/views/quality/disqualification/DisqualifierDetail.vue'
import { findAll } from '@/api/Api'
import { getOptions } from '@/utils/util'

export default {
  components: { DisqualifierList, DisqualifierDetail },
  props: {
    orderType: { type: Object },
    orderStatus: { type: Number, default: null }
  },
  data() {
    return {
      activeKey: 1,
      owners: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.fetch()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.edit(row)
    }
  }
}
</script>